

// # 公共数据配置
module.exports = {
    
    // # 网站标题
    title : 'Crypto',

    // # 请求超时时间，毫秒（默认2分钟）
    timeout: 1200000,

    // # 登录 Token 键值
    TokenKey: 'Authorization',

    // # 记住密码状态下的token在Cookie中存储时间，单位分钟
    // # 默认 7 Day = 60 * 24
    tokenCookieExpires: 7 * 60 * 24
}